function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`${name} env var is required`)
  }
  return value
}

export const API_URL = required('VITE_API_URL', import.meta.env.VITE_API_URL)
export const WS_URL = required('VITE_WS_URL', import.meta.env.VITE_WS_URL)
export const GA_ID = import.meta.env.VITE_GA_ID || null
